import * as yup from 'yup';

export interface Values {
  warningStatusReason: string;
}

export const initialValues: Values = {
  warningStatusReason: '',
};

export const SOFT_MAX_REASON_LENGTH = 240;
export const MAX_REASON_LENGTH = 240;

export const getValidationSchema = () =>
  yup.object({
    warningStatusReason: yup.string().customRequiredString().max(MAX_REASON_LENGTH),
  });
